import Raven from 'raven-js'

export default {
  login(info, remember = true) {
    // 一般ユーザーの場合はlocalStorageにもセッションを保存
    if (sessionStorage.is_aflac !== 'true') {
      // ログイン状態の保持がfalseの場合は保持期限もセット
      // trueの場合は、期限なしで永続する
      if (!remember) {
        this.setExpireTime()
      }
      localStorage.info = JSON.stringify(info)
    }
    sessionStorage.info = JSON.stringify(info)
  },

  async logout() {
    try {
      // api.jsでauth.jsを静的インポートしており、循環参照を避けるため動的インポート
      const { default: api } = await import('./api')
      await api.logout()
    } catch (e) {
      // Send errors to sentry and proceed with client logout
      Raven.captureException(e)
    } finally {
      this.removeAuthInfo();
    }
  },

  getInfo() {
    let info = null
    let now = new Date().getTime()

    if (localStorage.expire_time && now > localStorage.expire_time) {
      delete localStorage.info
      delete localStorage.expire_time
    }

    if (localStorage.info) {
      info = JSON.parse(localStorage.info)
      if (localStorage.expire_time) {
        // 期限内に getInfo() が呼ばれるたびにセッション期限が延長
        this.setExpireTime();
      }
    } else if (sessionStorage.info) {
      info = JSON.parse(sessionStorage.info)
    }

    return info
  },

  getAccessToken() {
    return this.getCustomerInfoBy('access_token')
  },

  getCustomerInfoBy(key) {
    let info = this.getInfo()

    if (info && info.status !== "failed" && info.customer.hasOwnProperty(key)) {
      return info.customer[key]
    }

    return null
  },

  updateCustomerInfo(data) {
    let customer = { ...data }
    if (!customer.access_token) {
      customer.access_token = this.getAccessToken()
    }
    let info = this.getInfo()
    info.customer = customer
    if (localStorage.info) {
      const localStorageInfo = JSON.parse(localStorage.info)
      localStorageInfo.customer.access_token = customer.access_token
      localStorageInfo.customer.authentication_code_verification = customer.authentication_code_verification
      localStorage.info = JSON.stringify(localStorageInfo)
    }

    this.login(info, Boolean(localStorage.info))
  },

  loggedIn() {
    let info = this.getInfo()
    return info !== null && info.status === 'success'
  },

  verifiedEmail() {
    return this.getCustomerInfoBy('email_verification')
  },

  verifiedAuthenticationCode() {
    return this.getCustomerInfoBy('authentication_code_verification')
  },

  setExpireTime() {
    let now = new Date().getTime()
    let localStorageTime = 12*60*60*1000 // Set expire time to 12 hours
    localStorage.expire_time = now + localStorageTime
  },

  removeAuthInfo() {
    delete localStorage.info;
    delete sessionStorage.info;
    delete localStorage.expire_time;
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth.js